// extracted by mini-css-extract-plugin
export default {"StoreLinks":"StoreLinks_StoreLinks__-0I5B"};